(function() {
  'use strict';
  angular.module('clientDashboardApp.admin.adminSearch.adminSearchService', []).service('adminSearchService', AdminSearchService);

  function AdminSearchService(){
    this.query = null;
  }

  AdminSearchService.prototype.setSearchQuery = function(query){
    this.query = query;
  }

  AdminSearchService.prototype.getSearchQuery = function(){
    return this.query;
  }

  AdminSearchService.prototype.resetQuery = function(){
    this.query = null;
  }

})();
